import { createFileRoute } from "@tanstack/react-router";
import { HoverCardExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/radix/hover-card")({
  component: HoverCardExamples,
});
